import React, { useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { UserRole } from '../../types/models';
interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
  allowedRegions?: ('main' | 'limpopo' | 'gauteng')[];
}
export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requireAdmin = false,
  allowedRegions
}) => {
  const {
    user,
    loading
  } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (!loading && !user) {
      navigate('/login');
    }
    if (!loading && user && requireAdmin && user.role !== 'admin') {
      navigate('/dashboard');
    }
    // Region-based access control
    if (!loading && user && allowedRegions && user.region) {
      // Main admin can access all regions
      if (user.adminType === 'main') {
        return;
      }
      // Regional admins can only access their own region
      if (!allowedRegions.includes(user.region)) {
        navigate('/admin/dashboard');
      }
    }
  }, [user, loading, requireAdmin, allowedRegions, navigate]);
  if (loading) {
    return <div data-id="element-323">Loading...</div>;
  }
  if (!user || requireAdmin && user.role !== 'admin') {
    return null;
  }
  return <>{children}</>;
};